export default __webpack_public_path__ + "static/media/imgCard1.fa391eab.svg";